import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './components/Layout/DashboardLayout';
import Login from './pages/Login';
import Statistics from './pages/Dashboard/Statistics';
import Analyses from './pages/Dashboard/Analyses';
import AgentStats from './pages/Dashboard/AgentStats';
import RingoverStats from './pages/Dashboard/RingoverStats';
import ManagerPhrases from './pages/Dashboard/ManagerPhrases';
import EvaluationCriteria from './pages/EvaluationCriteria';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard/stats" replace />} />
            <Route path="stats" element={<Statistics />} />
            <Route path="analyses" element={<Analyses />} />
            <Route path="agent-stats" element={<AgentStats />} />
            <Route path="ringover-stats" element={<RingoverStats />} />
            <Route path="manager-phrases" element={<ManagerPhrases />} />
            <Route path="evaluation-criteria" element={<EvaluationCriteria />} />
          </Route>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
